import React from 'react';
import { APP_PAGE_BLEED_ROOT, APP_PAGE_GUTTER } from '../../../utils/sessionMobileLayout';

const SESSIONS_PAGE_SHELL = `${APP_PAGE_BLEED_ROOT} min-h-screen bg-background`;
const SESSIONS_PAGE_INNER = `mx-auto max-w-app-shell ${APP_PAGE_GUTTER} pt-3 pb-8 md:pt-6`;

const SessionsPageShell = ({ children }) => (
  <div className={SESSIONS_PAGE_SHELL}>
    <div className={SESSIONS_PAGE_INNER}>{children}</div>
  </div>
);

export default SessionsPageShell;
